import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  id: "plan-c-mrp-claims-form",
  class: "form plan-c-mrp-claims",
  method: "POST"
}
const _hoisted_3 = { class: "cards" }
const _hoisted_4 = { class: "card transparent" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "New Claims", -1)
const _hoisted_7 = { class: "card transparent" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Existing Claims", -1)
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "table-wrapper" }
const _hoisted_12 = { class: "action-buttons sm-pdb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_CoveredCard = _resolveComponent("CoveredCard")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "Your most recent claims history is displayed below. To view a specific claim listed, click on the claim number. For those received via this website, but not yet reviewed, you can click on the Web Reference number to view /edit your uploaded documents or add additional documents. To search for a specific date range or for claims not listed below please click the Search button and choose your search criteria.",
      type: "primary",
      iconClass: "iatse-icon-alarm"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-primary plan-modal",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('claim-submission', 'New Claim Submission', 'plan-upload plan-card-info')), ["prevent"]))
                  }, " Submit a New Claim ")
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-primary full-width",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('claim-search', 'Claim History Search', 'plan-upload plan-card-info')), ["prevent"]))
                  }, " Go To Existing Claim ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_CoveredCard, { links: _ctx.links }, null, 8, ["links"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_DataTable, {
                  table: _ctx.data,
                  classes: "claims small equal-widths no-padding scrollable"
                }, null, 8, ["table"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-secondary plan-modal",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'medicare')), ["prevent"]))
                }, " Change Mailing Address / Claims Payment Setup "),
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-secondary plan-modal",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('claim-search', 'Claim History Search', 'plan-upload plan-card-info')), ["prevent"]))
                }, " Search Claim History ")
              ])
            ])
          ])
        ]))
  ], 64))
}